import { render, staticRenderFns } from "./BookingInfo.vue?vue&type=template&id=2fc7c707&scoped=true"
import script from "./BookingInfo.vue?vue&type=script&lang=js"
export * from "./BookingInfo.vue?vue&type=script&lang=js"
import style0 from "./BookingInfo.vue?vue&type=style&index=0&id=2fc7c707&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7c707",
  null
  
)

export default component.exports